import {
  GET_FFADMIN_ADDRESSES_REQ,
  GET_FFADMIN_ADDRESSES_SUCCESS,
  GET_FFADMIN_ADDRESSES_FAIL,
  GET_FFADMIN_ADDRESS_REQ,
  GET_FFADMIN_ADDRESS_SUCCESS,
  GET_FFADMIN_ADDRESS_FAIL,
  UPDATE_FFADMIN_ADDRESS_REQ,
  UPDATE_FFADMIN_ADDRESS_SUCCESS,
  UPDATE_FFADMIN_ADDRESS_FAIL,
  DELETE_FFADMIN_ADDRESS_REQ,
  DELETE_FFADMIN_ADDRESS_SUCCESS,
  DELETE_FFADMIN_ADDRESS_FAIL,
  CREATE_FFADMIN_ADDRESS_REQ,
  CREATE_FFADMIN_ADDRESS_SUCCESS,
  CREATE_FFADMIN_ADDRESS_FAIL,
  GET_FFADMIN_ADDRESS2_REQ,
  GET_FFADMIN_ADDRESS2_SUCCESS,
  GET_FFADMIN_ADDRESS2_FAIL,
  SET_FFADMIN_ADDRESS_DATA,
  SET_FFADMIN_ADDRESS_DATA1,
  SET_FFADMIN_ADDRESS_DATA2,
} from '../constants';

const INIT_STATE = {
  addresses: [],
  loading: false,
  addressData: {},
  addressData2: {},
};

const ffAdminAddressReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FFADMIN_ADDRESSES_REQ:
    case GET_FFADMIN_ADDRESS_REQ:
    case GET_FFADMIN_ADDRESS2_REQ:
      return {
        ...state,
        loading: true,
      };
    case GET_FFADMIN_ADDRESSES_SUCCESS:
      return {
        ...state,
        loading: false,
        addresses: action.payload,
      };

    case GET_FFADMIN_ADDRESS2_SUCCESS:
      return {
        ...state,
        addressData2: action.payload,
      };

    case GET_FFADMIN_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        addressData: action.payload,
      };
    case GET_FFADMIN_ADDRESSES_FAIL:
    case GET_FFADMIN_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case CREATE_FFADMIN_ADDRESS_REQ:
    case UPDATE_FFADMIN_ADDRESS_REQ:
    case DELETE_FFADMIN_ADDRESS_REQ:
      return {
        ...state,
        loading: true,
      };
    case CREATE_FFADMIN_ADDRESS_SUCCESS:
    case UPDATE_FFADMIN_ADDRESS_SUCCESS:
    case DELETE_FFADMIN_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_FFADMIN_ADDRESS_FAIL:
    case UPDATE_FFADMIN_ADDRESS_FAIL:
    case DELETE_FFADMIN_ADDRESS_FAIL:
    case GET_FFADMIN_ADDRESS2_FAIL:
      return {
        ...state,
        loading: false,
      };
    case SET_FFADMIN_ADDRESS_DATA:
      return {
        ...state,
        addressData: {},
        addressData2: {},
      };

    case SET_FFADMIN_ADDRESS_DATA1:
      return {
        ...state,
        addressData: {},
      };

    case SET_FFADMIN_ADDRESS_DATA2:
      return {
        ...state,
        addressData2: {},
      };

    default:
      return state;
  }
};
export default ffAdminAddressReducer;
